/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query LCRRoutePlanReadQuery($routePlanId: ID) {
  LCRRoutePlanRead(routePlanId: $routePlanId) {
    id,
    createdAt,
    updatedAt,
    status,
    message,
    VendorAccount {
      id,
      displayName
    }
      VendorAccounttDirectory {
      id,
      displayName
    }
    VendorAccountt {
      id,
      displayName,
      VendorAccount {
        id,
        displayName
      }
    }
  }
}
`
